import React from "react";
import Modal from "../../../../elements/Modal";
import ManageEligibility from "../ManageEligibility";

const ManageEligibilityModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl4" title={"Create New "}>
      <ManageEligibility getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageEligibilityModal;
